import { resolveRarityColor, type StorefrontRarityKey } from "@loot-os/api-contract";

import { cn } from "@loot-os/ui/lib/utils";

/**
 * Rarity chip, tinted to match the opener's spinner rails so a tier reads the
 * same everywhere a shopper sees it.
 *
 * `colors` is the tenant's `theme.rarity` map. Passing it is the point: the
 * colors reach the opener through `LootTheme`, so a badge that ignored them
 * would disagree with the spinner in the tenant's own store.
 *
 * `resolveRarityColor` normalizes to hex, which the alpha concatenation below
 * depends on — an `"r,g,b"` override (a legal stored form) would otherwise
 * produce `"168,85,24766"` and the browser would drop the border entirely.
 */
export function BoxRarityBadge({
  rarity,
  colors,
  className,
}: {
  rarity: number;
  colors?: Partial<Record<StorefrontRarityKey, string>> | null;
  className?: string;
}) {
  const { label, color } = resolveRarityColor(rarity, colors);
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-medium",
        className,
      )}
      style={{ borderColor: `${color}66`, color }}
    >
      <span className="size-1.5 rounded-full" style={{ background: color }} />
      {label}
    </span>
  );
}
